// CSS
import "@/styles/components/blogCardStyles.css";

// Mui Styles
import { StyledBlogCard } from "@/styles/mui/globalStyles";
import Typography from "@mui/material/Typography";

// Mui Icon
import constant from "@/config/constant";
import EditIcon from "@mui/icons-material/Edit";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

import { invoiceFormat } from "@/config/normalConfig";
export default function BlogCard(props) {
  let date, title;
  const { region_ids } = props;
  let regionStr = region_ids
    .map((region_id) => constant.regionType[region_id])
    .join(",");

  if (props.type === "notice") {
    date = props.time_created;
    title = props.title;
  }
  if (props.type === "dailydetail") {
    date = props.time_created;
    title = ` ${props.work_name}${invoiceFormat(props.id)}`;
  }
  return (
    <StyledBlogCard onClick={props.onClick}>
      <div className="blogContainer">
        <span className="shapeLeft" />
        <div className="blogIconContainer">
          <StickyNote2OutlinedIcon sx={{ fontSize: 24, zIndex: 11 }} />
        </div>
        <span className="filter" />
        <span className="blogTopBox" />
      </div>
      <div className="blogContentContainer">
        <Typography> {regionStr}</Typography>
        <Typography
          variant="caption"
          noWrap
          component="div"
          sx={{
            margin: "0px 0px 8px",
            lineHeight: "1.5",
            fontSize: "0.75rem",
            fontWeight: "400",
            color: "rgb(145, 158, 171)",
          }}
        >
          {moment(date).format("YYYY-MM-DD")}
        </Typography>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ fontWeight: "bold" }}
        >
          {title}
        </Typography>
        {props.type === "notice" && (
          <div className="bottomContainer">
            <div className="bottomContent">
              {props.notice_modified_by_fullname
                ? `${props.notice_modified_by_fullname} (${props.time_modified})`
                : props.notice_created_by_fullname}
              <EditIcon sx={{ fontSize: 14, marginLeft: 1 }} />
            </div>
          </div>
        )}
      </div>
    </StyledBlogCard>
  );
}
